window['bootstrapData'] = fetch('/api/2/private/bootstrap', {
  credentials: 'include',
  headers: {
    Accept: 'application/json',
  },
}).then(async x => {
  if (x.status !== 200) {
    const content = await x.text()
    throw new Error(`Bootstrap endpoint returned ${x.status}: ${content}`)
  }
  return x.json()
})
